var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadHeadshotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 299,
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.674806,
    y: 0.674806,
    width: 297.56,
    height: 297.56,
    rx: 6.52312,
    fill: "#005595",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 1.34961,
    strokeDasharray: "4.5 4.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_23943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2299 109.896C82.2299 72.8475 112.389 42.7019 149.454 42.7019C186.519 42.7019 216.678 72.8475 216.678 109.896C216.678 146.945 186.519 177.091 149.454 177.091C112.389 177.091 82.2299 146.945 82.2299 109.896ZM191.911 198.31H106.997C62.1334 198.31 25.6201 236.993 25.6201 307.45C25.6201 328.91 43.0701 318.552 64.5393 318.552H234.369C255.838 318.552 273.288 328.91 273.288 307.45C273.288 226.745 236.775 198.31 191.911 198.31Z",
    fill: "#005595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_23943"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.55078,
    y: 9.39467,
    width: 287.807,
    height: 287.807,
    rx: 7.19793,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadHeadshotAvatar);
export default __webpack_public_path__ + "static/media/upload_headshot_avatar.867b6d7333ec06dc1a5685538e7379f4.svg";
export { ForwardRef as ReactComponent };